export const CONFIG = {
  APP_TITLE: 'SME LOAN/FINANCING',
  PAGE_TITLE: 'Application Form',
};
